import { getContext } from 'svelte';
import type { createAuthContext } from '../createAuthContext';
import { Contexts } from '#lib/constants/contexts.js';

export const getAuthContext = () => {
	return getContext<ReturnType<typeof createAuthContext>>(Contexts.Auth);
};
